import { LinkButton } from '@stories/Components/Buttons/Button/Button';
import * as React from 'react';
import S from './RichText.styles';
const RichText = (props) => {
    if (!props.content) {
        return null;
    }
    const content = props.content.replaceAll('<scrupt', '<script').replaceAll('</scrupt', '</script');
    return (React.createElement(S.Container, { id: props.anchorId, "data-layout": props.layout ?? 'default', translations: props.translations },
        props.subheading || props.heading ? (React.createElement(S.HeadingContainer, null,
            props.subheading && React.createElement(S.SubHeading, null, props.subheading),
            props.heading && React.createElement(S.Heading, null, props.heading))) : null,
        React.createElement(S.ContentContainer, null,
            React.createElement(S.Content, { dangerouslySetInnerHTML: { __html: content } }),
            props.ctas && (React.createElement(S.CtasContainer, null, props.ctas.map((cta) => (React.createElement(LinkButton, { key: cta.text, buttonType: cta.buttonType ? cta.buttonType : 'secondary', href: cta.url, target: cta.target, icon: cta.icon }, cta.text))))))));
};
export default RichText;
